<template>
  <div>
    <application-creator/>
    <webhook-editor/>
    <link-bot-editor/>
    <token-generator/>
    <event-creator/>
    <event-example-viewer/>
  </div>
</template>

<script>
export default {
  name: "Dialogs",
  components: {
    ApplicationCreator: () => import(
        './ApplicationCreator'
        ),
    WebhookEditor: () => import(
        './WebhookEditor'
    ),
    LinkBotEditor: () => import(
        './LinkBotEditor'
        ),
    TokenGenerator: () => import(
        './TokenGenerator'
        ),
    EventCreator: () => import(
        './EventForm'
        ),
    EventExampleViewer: () => import(
        './EventExampleViewer'
        )
  }
}
</script>

<style scoped>

</style>
